export const DEFAULT_MEDIA_AMOUNT_FOR_ABOUTUS = 4;
export const DEFAULT_MEDIA_AMOUNT_FOR_ABOUTUS_SUBPAGE = 100;
export const LIMIT_AFFILIATES_LIST = 10;
